(function ($) {
  DJ.addBehavior('activitySectionValidation', '.brio-media-validation', {
    attach: function () {
      const questionsHolder = this;
      const question1 = questionsHolder.querySelector('[data-drupal-selector="edit-question-1"]');
      const question2 = questionsHolder.querySelector('[data-drupal-selector="edit-question-2"]');
      const question3 = questionsHolder.querySelector('[data-drupal-selector="edit-question-3"]');
      const textRelated1 = questionsHolder.querySelector('[data-drupal-selector="edit-related-text-1"]');
      const textRelated2 = questionsHolder.querySelector('[data-drupal-selector="edit-related-text-2"]');
      const textRelated3 = questionsHolder.querySelector('[data-drupal-selector="edit-related-text-3"]');
      const textRelated4 = questionsHolder.querySelector('[data-drupal-selector="edit-related-text-4"]');
      const validateButton = questionsHolder.querySelector('.form-actions [data-drupal-selector="edit-validate"]');
      const visibleClass = 'brio-media-validation-element--show';

      // return false if no questions
      if (!question1 && !question2 && !question3
        && !textRelated1 && !textRelated2 && !textRelated3 && !textRelated4) {
        return false;
      }

      // enable validation button.
      const enableValidateButton = () => {
        if (validateButton) {
          validateButton.removeAttribute('disabled');
        }
      };

      // disable validation button.
      const disableValidateButton = () => {
        if (validateButton) {
          validateButton.setAttribute('disabled', '');
        }
      };

      disableValidateButton();

      // uncheck radios and refresh jcf plugin.
      const refreshRadios = (radiosToRefresh) => {
        if (radiosToRefresh.length > 0) {
          const elementsArr = Array.prototype.slice.call(radiosToRefresh);

          elementsArr.forEach((e) => {
            e.checked = false;
          });

          jcf.refresh($(radiosToRefresh));
        }
      };

      // question 1 event
      const question1Event = (questionRadio) => {
        const otherQuestionsRadio = questionsHolder.querySelectorAll('.form-radio:not([data-drupal-selector="edit-question-1"] .form-radio)');

        refreshRadios(otherQuestionsRadio);
        question3.classList.remove(visibleClass);
        textRelated4.classList.remove(visibleClass);
        textRelated2.classList.remove(visibleClass);
        textRelated3.classList.remove(visibleClass);

        if (questionRadio.value === 'yes') {
          question2.classList.add(visibleClass);
          textRelated1.classList.remove(visibleClass);
          disableValidateButton();
        } else {
          question2.classList.remove(visibleClass);
          textRelated1.classList.add(visibleClass);
          enableValidateButton();
        }
      };

      // question 2 event
      const question2Event = (questionRadio) => {
        const otherQuestionsRadio = questionsHolder
          .querySelectorAll('.form-radio:not([data-drupal-selector="edit-question-1"] .form-radio):not([data-drupal-selector="edit-question-2"] .form-radio)');

        refreshRadios(otherQuestionsRadio);

        textRelated2.classList.remove(visibleClass);
        textRelated3.classList.remove(visibleClass);

        if (questionRadio.value === 'yes') {
          textRelated4.classList.add(visibleClass);
          question3.classList.remove(visibleClass);
          enableValidateButton();
        } else {
          question3.classList.add(visibleClass);
          textRelated4.classList.remove(visibleClass);
          disableValidateButton();
        }
      };

      // question 3 event
      const question3Event = (questionRadio) => {
        enableValidateButton();

        if (questionRadio.value === 'yes') {
          textRelated3.classList.add(visibleClass);
          textRelated2.classList.remove(visibleClass);
        } else {
          textRelated3.classList.remove(visibleClass);
          textRelated2.classList.add(visibleClass);
        }
      };

      /**
       * Add event listener 'change' to radio buttons.
       * @param question
       *    Question selector.
       * @param isInit
       *    is function used for global first init or for question elements.
       * @param questionEvent
       *    event to bind on radio buttons.
       */
      const questionOnChange = (question, isInit, questionEvent) => {
        const questionsRadio = question.querySelectorAll('.form-radio');

        if (questionsRadio.length === 0) {
          return false;
        }

        const elementsArr = Array.prototype.slice.call(questionsRadio);

        elementsArr.forEach((e) => {
          if (isInit) {
            e.checked = false;
          } else {
            e.addEventListener('change', () => {
              questionEvent(e);
            });
          }
        });

        if (isInit) {
          jcf.refresh($(questionsRadio));
        }

        return true;
      };

      // first init of the questions. Uncheck all radios.
      questionOnChange(questionsHolder, true);

      // question 1 init
      questionOnChange(question1, false, question1Event);

      // question 2 init
      questionOnChange(question2, false, question2Event);

      // question 3 init
      questionOnChange(question3, false, question3Event);

      return true;
    }
  });
})(jQuery);
